'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

var _devLogger = require('react-utils/devLogger');

var _devLogger2 = _interopRequireDefault(_devLogger);

var _UIButtonWrapper = require('../layout/UIButtonWrapper');

var _UIButtonWrapper2 = _interopRequireDefault(_UIButtonWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ALIGNMENT_OPTIONS = {
  between: 'between',
  left: 'start',
  center: 'center',
  right: 'end'
};

exports.default = _react2.default.createClass({
  displayName: 'UIDialogFooter',

  propTypes: {
    align: _react.PropTypes.oneOf(['left', 'center', 'right', 'between']).isRequired,
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    layout: _UIButtonWrapper2.default.propTypes.layout
  },

  getDefaultProps: function getDefaultProps() {
    return {
      align: 'left'
    };
  },
  getAlignment: function getAlignment(_ref) {
    var align = _ref.align;

    return ALIGNMENT_OPTIONS[align];
  },
  getClassName: function getClassName(_ref2) {
    var className = _ref2.className;

    return (0, _reactUtils.classNames)('private-modal__footer', 'uiDialogFooter', className);
  },
  getLayoutType: function getLayoutType(_ref3) {
    var className = _ref3.className,
        layout = _ref3.layout;

    if (layout) return layout;

    if (className) {
      _devLogger2.default.warn({
        message: 'UIDialogFooter: Button layout is now improved out-of-the-box, but ' + "we didn't want to risk breaking any custom styling in your app. " + 'Remove this warning by setting layout="default" and seeing if you ' + 'still need your custom styles added via "className" or set it to ' + 'layout="legacy" to keep everything as it was.',
        key: 'UIDialogFooter: check classNames'
      });
      return 'legacy';
    }

    return 'default';
  },
  render: function render() {
    var _props = this.props,
        align = _props.align,
        children = _props.children,
        className = _props.className,
        layout = _props.layout,
        rest = _objectWithoutProperties(_props, ['align', 'children', 'className', 'layout']);

    return _react2.default.createElement(
      'footer',
      _extends({}, rest, { className: this.getClassName({ className: className }) }),
      _react2.default.createElement(
        _UIButtonWrapper2.default,
        {
          justify: this.getAlignment({ align: align }),
          layout: this.getLayoutType({ className: className, layout: layout })
        },
        children
      )
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/dialog/UIDialogFooter.js
// module id = 334
// module chunks = 0